import firebase from 'firebase/app'
import 'firebase/firebase-messaging'

var firebaseConfig = {
    apiKey: "AIzaSyC3exmndNDPvFebBc-loHnqzvUMeLMvQBI",
    authDomain: "qlnt-hse.firebaseapp.com",
    projectId: "qlnt-hse",
    storageBucket: "qlnt-hse.appspot.com",
    messagingSenderId: "197562376368",
    appId: "1:197562376368:web:992931997a4f68595d1b75",
    measurementId: "G-L3RVLFDTVF"
}

firebase.initializeApp(firebaseConfig)

let messaging;
if (firebase.messaging.isSupported()) {
    messaging = firebase.messaging();
} else {
    console.warn('Firebase Messaging is not supported on this device.');
}

export default messaging;
// export default firebase.messaging()